<div class="toolbar">
    <button mat-button (click)="goBack()" class="lt set-btn-back-res mat-custom-btn">
    <mat-icon>keyboard_backspace</mat-icon> {{ 'LABEL.BACK' | translate }}
  </button>
    <div class="action" *ngIf="order">

        <div class="downloads-group" *ngIf="order?.status == PAYMENT_STATUS.PAID">
            <ng-container *ngIf="order.order_tx_number">
                <button [disabled]="isDownloadingReceipt" *ngIf="!order.is_pickup" class="download-btn mat-custom-btn" color="accent" (click)="downloadTickets()" mat-flat-button>
          <mat-icon class="mat-icon-small">downloads</mat-icon>
          <span> {{ 'LABEL.TICKETS' | translate }} </span>
        </button>
                <button [disabled]="isDownloadingReceipt" class="download-btn mat-custom-btn" color="accent" (click)="downloadReceipt()" mat-flat-button>
          <mat-icon class="mat-icon-small">downloads</mat-icon>
          <span> {{ 'LABEL.DOWNLOAD_RECEIPT' | translate }} </span>
        </button>
            </ng-container>
            <button *ngIf="order?.status == PAYMENT_STATUS.PAID && !order.order_tx_number" class="download-btn mat-custom-btn" color="accent" (click)="reSubmit()" mat-flat-button>
        <span> {{ 'LABEL.RE_SUBMIT' | translate }} </span>
      </button>
        </div>
        <div class="downloads-group" *ngIf="isUnPaid">
            <a class="mat-button mat-custom-btn" color="primary" mat-flat-button routerLink="/order/edit" [queryParams]="{ id: order._id }">
                <mat-icon class="mat-icon">border_color</mat-icon> {{'LABEL.EDIT' | translate}}
            </a>
            <button (click)="onDelete()" class="mat-custom-btn" mat-flat-button color="warn">
        <mat-icon class="mat-icon-small">delete</mat-icon>
        <span> {{ 'LABEL.DELETE' | translate }}</span>
      </button>
        </div>

        <!-- <div class="downloads-group" *ngIf="isPaid; else unPaid">
            <ng-container *ngIf="order.order_tx_number">
                <button [disabled]="isDownloadingReceipt" *ngIf="!order.is_pickup" class="download-btn mat-custom-btn"
                    color="accent" (click)="downloadTickets()" mat-flat-button>
                    <mat-icon class="mat-icon-small">downloads</mat-icon>
                    <span> {{ 'LABEL.TICKETS' | translate }} </span>
                </button>
                <button [disabled]="isDownloadingReceipt" class="download-btn mat-custom-btn" color="accent"
                    (click)="downloadReceipt()" mat-flat-button>
                    <mat-icon class="mat-icon-small">downloads</mat-icon>
                    <span> {{ 'LABEL.DOWNLOAD_RECEIPT' | translate }} </span>
                </button>
            </ng-container>
            <button *ngIf="isPaid && !order.order_tx_number" class="download-btn mat-custom-btn" color="accent"
                (click)="reSubmit()" mat-flat-button>
                <span> {{ 'LABEL.RE_SUBMIT' | translate }} </span>
            </button>
        </div>
        <ng-template #unPaid>
            <a class="mat-button mat-custom-btn" color="primary" mat-flat-button routerLink="/order/edit"
                [queryParams]="{ id: order._id }"><mat-icon class="mat-icon">border_color</mat-icon> {{'LABEL.EDIT' |
                translate}}</a>
            <button (click)="onDelete()" class="mat-custom-btn" mat-flat-button color="warn">
                <mat-icon class="mat-icon-small">delete</mat-icon>
                <span> {{ 'LABEL.DELETE' | translate }}</span>
            </button>
        </ng-template> -->
    </div>
</div>
<div class="content" @fadeOp *ngIf="order">
    <div class="purchase-summary set-font-family">
        <h3>
            <mat-icon svgIcon="paper"></mat-icon> {{ 'PUBLIC.PURCHASE_SAMMARY' | translate }}</h3>
        <div class="order-detail">
            <app-order-card-info [day]="order?.num_ticket" [passType]="order.system" [typeName]="lang != 'km' ? ticketType.name : ticketType.long_name" [numDay]="ticketType.num_day" [quantity]="order.num_ticket" [isPaid]="isPaid" [isPickup]="order.is_pickup" [orderDate]="isPaid ? order.order_date : null"
                [startDate]="order.start_date" [endDate]="order.expired_date" [totalPrice]="order.total_price" [paymentStatus]="order.status" [referenceID]="isPaid ? (order.order_tx_number) : null" [code]="order.code" [createdDate]="order.createdAt" [isView]="true"
                [channel]="order.channel">
            </app-order-card-info>
        </div>
    </div>
    <div class="visitor-summary set-font-family">
        <h3>
            <mat-icon svgIcon="ticket_type"></mat-icon> {{'LABEL.TICKET_INFO' | translate}}</h3>
        <div class="table-container">
            <table mat-table [dataSource]="tickets" class="tr">
                <ng-container matColumnDef="no">
                    <th class="header-cell" mat-header-cell *matHeaderCellDef align="center">{{ "TABLE.NO" | translate }}</th>
                    <td mat-cell *matCellDef="let i = index" align="center"> {{ i + 1 }}</td>
                </ng-container>

                <ng-container matColumnDef="image">
                    <th class="header-cell" mat-header-cell *matHeaderCellDef align="center">{{ 'TABLE.PHOTO' | translate }}</th>
                    <td mat-cell *matCellDef="let user" align="center">
                        <div class="image-cont">
                            <app-image class="avatar" [avatar]="true" [width]="50" [height]="50" alt="image profile" [id]="user.ticket.photo"></app-image>
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="start_date">
                    <th class="header-cell" mat-header-cell *matHeaderCellDef align="center">{{ "TABLE.VISIT_DATE" | translate }}
                    </th>
                    <td mat-cell *matCellDef="let user" align="center">{{ setDateFormat(user.ticket.start_date) }}</td>
                </ng-container>

                <ng-container matColumnDef="end_date">
                    <th class="header-cell" mat-header-cell *matHeaderCellDef align="center">{{ "TABLE.EXPIRE_DATE" | translate }}
                    </th>
                    <td mat-cell *matCellDef="let user" align="center">
                        {{ setDateFormat(user.ticket.expired_date) }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="national">
                    <th class="header-cell" mat-header-cell *matHeaderCellDef align="center">{{ 'TABLE.NATIONALITY' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let user" align="center">
                        <!-- {{'NATIONALITIES.' + getNationalityByID(user.ticket?.nationality).nationality | translate }} -->
                        {{getNationalityByID(user.ticket?.nationality)}}


                    </td>
                </ng-container>
                <tr class="header-row" mat-header-row *matHeaderRowDef="DISPLAY_COLUMN"></tr>
                <tr mat-row *matRowDef="let row; columns: DISPLAY_COLUMN"></tr>
            </table>
        </div>

        <!-- </ng-template> -->


        <div class="text-note">
            <p class="text-note" *ngIf="isPaid; else unpaidAction"><span>{{ 'LABEL.NOTE' | translate }} </span>{{ 'LABEL.VISITING_NOTE' | translate }}</p>
        </div>
        <div class="footer-action" *ngIf="(isUnPaid || isInPayment) && isTodayOrFuture">
            <div class="agree">
                <mat-checkbox [formControl]="isAgree"> {{ 'PUBLIC.I_AGREE' | translate }} </mat-checkbox>
                <a class="accent" (click)="onAgree()" style="cursor: pointer; margin-left: 3px;">{{ 'PUBLIC.TERMS_AND_CON' |
          translate}}</a>
            </div>
            <button color="accent" class="download-btn mat-custom-btn btn-sumbit" mat-flat-button [disabled]="!isAgree.value" (click)="onCheckout()">
        {{'LABEL.CHECK_OUT' | translate}}<mat-icon class="mat-icon">arrow_forward_ios</mat-icon>
      </button>
        </div>
    </div>
</div>
<!-- ABA Payment -->
<div id="aba_main_modal" class="aba-modal">
    <div class="aba-modal-content">
        <form method="POST" class="hidden" [action]="payment?.action_url" id="aba_merchant_request">
            <input type="text" *ngFor="let key of payment | keyvalue" type="hidden" [name]="key.key" [value]="key.value" [id]="key.key">
        </form>
    </div>
</div>

<!-- ACLEDA Payment -->
<form method="POST" class="hidden" id="_xpayTestForm" name="_xpayTestForm" [action]="actionUrl">
    <input *ngFor="let key of paymentKey" id="{{key}}" type="hidden" name="{{key}}" value="{{paymentInfo[key]}}" />
    <script>
        $(document).ready(function() {
            function disableBack() {
                window.history.forward()
            }
            window.onload = disableBack();
            window.onpageshow = function(evt) {
                if (evt.persisted) disableBack()
            }
        });
    </script>
</form>

<!-- TurnStile -->
<div id="turnstile-widget"></div>
